import { Navigate } from "react-router-dom";

function AdminProtectedRoute({ children }) {

    const token = localStorage.getItem("token");

    const user = JSON.parse(
        localStorage.getItem("user")
    );

    if (!token) {

        return <Navigate to="/admin/login" />;

    }

    if (!user || user.role !== "admin") {

        return <Navigate to="/" />;

    }

    return children;

}

export default AdminProtectedRoute;